var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-wrapper" }, [
    _c(
      "section",
      { staticClass: "hero hero--full" },
      [
        _c(
          "hero-content",
          { attrs: { title: _vm.$helpers.trans("errors.404.title") } },
          [
            _c("p", [
              _vm._v(_vm._s(_vm.$helpers.trans("errors.404.description")))
            ]),
            _vm._v(" "),
            _c("a", { staticClass: "btn btn-primary", attrs: { href: "/" } }, [
              _vm._v(_vm._s(_vm.$helpers.trans("errors.404.label")))
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd9bf27a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd9bf27a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../default-js/js/components/errors/404.vue
// module id = 265
// module chunks = 17